export default __webpack_public_path__ + "static/media/bin.f2af4551.png";